import React from 'react';

class ImageHalf extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        let align = this.props.align ? 'ml-auto' : '';

        return (
            <section className="section">
                <div className="main-container">
                    <div className="inner-container">
                        <figure className={`half-figure ${align}`}>
                            <img src={this.props.imgsrc} alt="ProjctTitle" title="ProjctTitle"/>
                        </figure>
                    </div>
                </div>
            </section>
        );
    }
}
export default ImageHalf;



// WEBPACK FOOTER //
// ./src/components/Projects/Details/ImageHalf.js